import { ArrayOps } from '../lift';
/**
 * Drops the first 'count' items from this Array.
 */
export function drop(count) {
    return new ArrayOps(this.value().slice(count));
}
ArrayOps.prototype.drop = drop;
